import { requestSaga } from 'common/utils/generators';
import resources from 'common/constants/resources';
import dataProvider from 'store/dataProvider';
import { actionTypes } from '../reducer';

function* updatePhone() {
  yield requestSaga({
    actionType: actionTypes.update,
    request: dataProvider.updateOne,
    resource: resources.simCard.index,
  });
}

export default updatePhone;
